import { defineComponent as _defineComponent } from 'vue'
import CreditAndMarkToMarketManagement from 'ah-trades/src/components/creditAndMarkToMarket/CreditAndMarkToMarketManagement.vue';
import { useOnBehalfOf } from 'ah-common-lib/src/onBehalfOf/useInjectedOBO';
import { useRouter } from 'vue-router/composables';


export default /*#__PURE__*/_defineComponent({
  __name: 'ActivitySingleClientCreditAndMTMView',
  props: {
  /**
   * Client ID to display credit and mark-to-market for, if any (CreditAndMarkToMarketManagement will default to contextual owner id otherwise)
   */
  clientId: {
    type: String,
  },
},
  setup(__props) {



const onBehalfOfClient = useOnBehalfOf();

const router = useRouter();

/**
 * We are using onBehalfOfClient.value?.id instead of props.clientId because the go back button
 * will only show when we are acting on behalf of, thus is to keep the consistency
 */
function goBack() {
  router.push('/admin/activity/clients/obo/' + onBehalfOfClient.value?.id);
}

return { __sfc: true,onBehalfOfClient, router, goBack, CreditAndMarkToMarketManagement }
}

})